import { Box, TextField, InputAdornment, SearchIcon, IconButton, CloseIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function SearchBar({
  searchValue,
  setSearchValue,
  handleSearchFocus = () => {},
  handleExitSearch = () => {},
  placeholder = "Search..."
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Box sx={{ mb: 2 }}>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          autoFocus
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          InputLabelProps={{ style: { fontSize: 14 } }}
          InputProps={{
            sx: { borderRadius: 100, fontSize: 14 },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleExitSearch}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    );
  }

  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      placeholder={placeholder}
      value={searchValue}
      onFocus={handleSearchFocus}
      onChange={(e) => setSearchValue(e.target.value)}
      onBlur={() => {
        setTimeout(() => {
          if (!searchValue) handleExitSearch();
        }, 100);
      }}
      InputLabelProps={{ style: { fontSize: 12 } }}
      InputProps={{
        sx: { backgroundColor: 'white', borderRadius: 100, fontSize: 12 },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: searchValue && (
          <InputAdornment position="end">
            <IconButton
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                setSearchValue("");
                handleExitSearch();
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
}
